import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Col,
  Row,
  Card,
  Table,
  Modal,
  Button,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { TableRow } from "../component/TableRow";
import Pagination from "../../../../components/Pagination";
import { Context } from "../Reward";
import { Routes } from "../../../../routes";
import RewardDetail from "../sub-screen/reward-detail/RewardDetail";
import PayReward from "../sub-screen/pay-reward/PayReward";
import PayRewardAll from "../sub-screen/pay-reward-all/PayRewardAll";

const _Table = () => {
  const { state, dispatch } = useContext(Context);

  const [modalShow, setModalShow] = useState(false);

  const [payModalShow, setPayModalShow] = useState(false);

  const [payAllModalShow, setPayAllModalShow] = useState(false);

  const [membersModalShow, setMembersModalShow] = useState(false);
  const [membersData, setMembersData] = useState([]);
  const [membersGroupId, setMembersGroupId] = useState("");
  const [membersReward, setMembersReward] = useState(0);
  const [membersEstimatedValue, setMembersEstimatedValue] = useState(0);

  const rewardRef = useRef({});

  const transIdRef = useRef("");
  const userIdRef = useRef("");
  const ticketIdRef = useRef("");
  const cartGroupIdRef = useRef("");
  const onShowDetailPress = (reward) => {
    rewardRef.current = reward;
    setModalShow(true);
  };

  const onPaidPress = (id, userId, cartGroupId, ticketId) => {
    userIdRef.current = userId;
    cartGroupIdRef.current = cartGroupId;
    transIdRef.current = id;
    ticketIdRef.current = ticketId;
    setPayModalShow(true);
  };

  const onShowMembersPress = (
    members,
    cartGroupId,
    netValue,
    estimatedValue,
  ) => {
    setMembersData(members);
    setMembersGroupId(cartGroupId);
    setMembersReward(Number(netValue) || 0);
    setMembersEstimatedValue(Number(estimatedValue) || 0);
    setMembersModalShow(true);
  };

  useEffect(() => {
    if (state.isPaying) {
      setPayAllModalShow(true);
    } else {
      setPayAllModalShow(false);
    }
  }, [state.isPaying]);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table
          responsive
          className="align-items-center table-bordered table-hover"
        >
          <thead className="text-center">
            <tr>
              <th scope="col">Thao tác</th>
              <th scope="col">Người chơi / Nhóm</th>
              <th scope="col">Mã vé</th>
              <th scope="col">Thiết bị in</th>
              <th scope="col">Chi tiết</th>
              <th scope="col">Hình ảnh</th>
              <th scope="col">Giải thưởng</th>
              <th scope="col">Thuế</th>
              <th scope="col">Phí</th>
              <th scope="col">Thực nhận</th>
              <th scope="col">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {state.loading ? (
              <tr>
                <td colSpan={11} className="text-center">
                  Đang tải dữ liệu
                </td>
              </tr>
            ) : (
              state.data.list &&
              state.data.list.map((pv, index) => (
                <TableRow
                  onPaidPress={onPaidPress}
                  onShowDetailPress={onShowDetailPress}
                  onShowMembersPress={onShowMembersPress}
                  rIndex={index}
                  key={`table-keys-lottmekong-${pv.id}`}
                  data={pv}
                />
              ))
            )}
          </tbody>
        </Table>
        <Card.Footer className="flex-row">
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={state.data.totalPage || 0}
                currentPage={state.filter.page || 0}
                onPageChange={(i) => {
                  dispatch({
                    type: "UPDATE_PAGE",
                    payload: i,
                  });
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <RewardDetail
        show={modalShow}
        reward={rewardRef.current}
        onHide={() => setModalShow(false)}
      />
      <PayReward
        show={payModalShow}
        transId={transIdRef.current}
        userId={userIdRef.current}
        cartGroupId={cartGroupIdRef.current}
        ticketId={ticketIdRef.current}
        onHide={(status) => {
          if (status === 1) {
            const newData = JSON.parse(JSON.stringify(state.data));

            for (let index = 0; index < newData.list.length; index++) {
              const element = newData.list[index];

              if (element.id === transIdRef.current) {
                element.isPaid = true;
                break;
              }
            }

            dispatch({
              type: "UPDATE_DATA",
              payload: newData,
            });

            setPayModalShow(false);
          } else {
            setPayModalShow(false);
          }
        }}
      />
      <PayRewardAll
        show={payAllModalShow}
        onHide={(completed) => {
          dispatch({
            type: "PAY_REWARD_ALL",
          });
          if (completed) {
            dispatch({
              type: "SUBMIT_FILTER",
              payload: state.filter,
            });
          }
        }}
      />
      <Modal
        show={membersModalShow}
        onHide={() => setMembersModalShow(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: "normal", fontSize: 15 }}>
            Danh sách thành viên - Nhóm:{" "}
            <Link
              to={Routes.VietlottGroupDetail.path.replace(
                ":id",
                membersGroupId,
              )}
              target="_blank"
              style={{ textDecoration: "underline", color: "#0d6efd" }}
            >
              <strong>{membersGroupId}</strong>
            </Link>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginBottom: 12 }}>
            <span>
              Tổng giải thưởng:{" "}
              <strong className="text-success">
                {new Intl.NumberFormat("vn-VI", {}).format(membersReward)}
              </strong>
            </span>
          </div>
          <Table
            responsive
            className="align-items-center table-bordered table-hover"
          >
            <thead className="text-center">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Họ tên</th>
                <th scope="col">Số điện thoại</th>
                <th scope="col">Tỷ lệ</th>
                <th scope="col">Giải thưởng</th>
              </tr>
            </thead>
            <tbody>
              {membersData.map((m, idx) => {
                const memberValue = Number(m.value) || 0;
                const percent =
                  membersEstimatedValue > 0
                    ? (memberValue / membersEstimatedValue) * 100
                    : 0;
                const memberReward =
                  membersReward > 0
                    ? Math.round((membersReward * percent) / 100)
                    : 0;
                return (
                  <tr key={m.id || idx}>
                    <td className="text-center">{idx + 1}</td>
                    <td>
                      <b>{m.user?.name || ""}</b>
                    </td>
                    <td>
                      <strong className="text-primary">
                        {m.user?.phone || ""}
                      </strong>
                    </td>
                    <td className="text-center">{percent.toFixed(2)}%</td>
                    <td className="text-right text-success">
                      <b>
                        {new Intl.NumberFormat("vn-VI", {}).format(
                          memberReward,
                        )}
                      </b>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setMembersModalShow(false)}
          >
            Đóng
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default React.memo(_Table);
